const data = {
  'Home.message': "It's a beautiful day outside.",
  'home.beauty_advisor': 'Beauty Advisor',
  'home.virtual_mirror': 'Virtual Mirror',
  'home.lens_find': 'إكتشف العدسة الأنسب لك',
  'home.lens_continue': 'اضغط للاستمرار',
  'home.quiz_find': 'Find my persona',
  'home.logout': 'تسجيل الخروج',
  'home.let_us_find': 'Let us find the',
  'home.look_for_you': 'look for you',
  'home.try_a_lens': 'Try a lens',
  'home.color': 'color',
  'without_quiz.lens_color': 'Try a lens color',
  'without_quiz.access_cam': '<sup>®</sup>DEFINE ترغب في استخدام الكاميرا ',
  'without_quiz.access_cam_sub_text': 'تُستخدم في التجربة الحية',
  'without_image.img_confirm': 'Are you sure you want to use this image?',
  'without_image.Allow': "لا أسمح",
  'without_image.OK': 'موافق',
  'dba.find_look': 'Let us find the look for you',
  'dba.about_urself': 'Tell us more about yourself',
  'dba.trydba': 'Try the DBA App',
  'dba.next': 'Next',
  'dba.Currently wearing:': 'Currently wearing:',
  'quiz.skin_color': 'What is your skin tone color?',
  'quiz.hair_Color': 'What is your hair color?',
  'menu.home': 'الرئيسية',
  'menu.bye': 'Bye',
  'menu.share': 'Share',
  'menu.save': 'Save',
  'menu.trail': 'Free trial',
  'menu.find': 'Find Doctor',
  'menu.product': 'Product Info',
  'lens.bright': 'Radiant Bright™',
  'lens.shine': 'Natural Shine™',
  'lens.charm': 'Radiant Charm™',
  'lens.chic': 'Radiant Chic™',
  'lens.sweet': 'Radiant Sweet™',
  'lens.vivid': 'Vivid Style',
  'lens.accent': 'Accent Style',
  'footer.care': 'About Lens Care',
  'footer.products': 'About Products',
  'footer.legal': 'إشعار قانوني',
  'footer.acuvue': 'معلومات عن <span dir="ltr">1-DAY ACUVUE<sup>®</sup> DEFINE<sup>®</sup> FRESH</span>',
  'footer.contact': 'Contact Us',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.cookiePolicy':'سياسة ملفات الإرتباط',
  'footer.label': 'About',
  'footer.makeup': 'Makeup Tutorial',
  'login.email': 'E-mail',
  'login.password': 'Password',
  'login.submit': 'Submit',
  'nav.welcome_guest': 'Welcome Guest',
  'vm.currently_wearing': 'Currently Wearing',
  'vm.rec_variant': 'Recommended Variant',
  'product_info.about': 'نبذة عن عدساتنا',
  'lens.now': 'Now',
  'tabs.classic_lenses': 'Define Classic',
  'tabs.fresh_lenses': 'Define Fresh',
  'tabs.looks': 'Looks',  
  'tabs.makeup': 'مظاهر مع المكياج',
  'tabs.insertion': 'ارتداء العدسات',
  'tabs.removal': 'إزالة العدسات',
  'tooltip.home': 'الرئيسية',
  'tooltip.ba': 'Beauty Advisor',
  'tooltip.care': 'Lens Care',
  'tooltip.more': 'More Options',
  'tooltip.buy': 'Buy',
  'tooltip.share': 'Share',
  'tooltip.trial': 'Free Trial',
  'tooltip.ecp': 'Find ECP',
  'tooltip.logout': 'تسجيل الخروج',
  'tooltip.vm': 'Virtual Try On',
  'modal.share': 'Share',
  'modal.buy': 'Buy',
  'modal.free_trial': 'Free Trial',
  'modal.shop_now': 'Shop Now',
  'modal.go': 'Go',
  'looks.downloadPdf': 'Download Tutorial',
  'guides.how_to_put_on_lens': 'كيفية ارتداء العدسات اللاصقة في 4 خطوات سهلة',
  'guides.how_to_remove_lens': 'كيفية إزالة العدسات اللاصقة في 4 خطوات سهلة',
  'looks.you_have_selected': 'You have selected: ',
  'tutorials.or': 'OR',
  'tutorials.scan': 'Scan QR code to download',
  'tutorials.product_unavailable':
  'This product is currently unavailable in this market.',
  'tutorials.look': 'Look ',
  'products.disclaimer_header': 'المراجع/إخلاء المسؤولية',
  'tutorials.purchase': 'Buy online',
  'tutorials.lens': 'Lens',
  'looks.best_suited': 'look is best suited with',
  'looks.product_unavailable': 'Not Available',
  'looks.you_have_chosen': 'لقد اخترت ',
  'looks.with_lens': 'With Lens:',
  'looks.with_looks': 'With Looks:',
  'modal.buy_button': 'احجز موعداً',
  'permissions.allow_look_removal': 'This action would remove applied look',
  'permissions.allow_makeup_removal': 'This action would remove applied makeup',
  'permissions.allow_look_removal_sub_text': 'Do you want to proceed?',
  'tabs.pls_select_look': 'Please select a look',
  'tabs.pls_select_lens': 'يرجى إختيار العدسة',
  'tabs.pls_select_makeup_category': 'Please select a makeup category',
  'button.value_try_the': 'جربي',
  'button.heading_try_the': 'العدسة',
  'button.value_find_your': 'Find Your',
  'button.heading_find_your': 'Persona',
  'button.value_price': '$20',
  'button.heading_price': 'Reward',
  'products.external_buy': 'تجربة مجانية',
  'product.browser-alert' : 'أنت تقر بأن الصورة التي تقوم برفعها أو التقاطها عبر الكاميرا سيتم استخدامها فقط لأغراض استخدام "المرآة الافتراضية". ولن يتم تخزين هذه الصورة بصورة دائمة ولن تكون متاحة للعامة أو للمستخدمين الآخرين لهذه الخدمة، كما سيتم محوها بمجرد إغلاقك لصفحة الويب. لمزيد من المعلومات أو للاتصال بنا، يرجى الرجوع لسياسة الخصوصية الكاملة الخاصة بنا، والمتاحة على <a class=" text-blue text-bold" href="https://www.acuvuearabia.com/privacy-policy" target="_blank">www.acuvuearabia.com/privacy-policy</a>',
  'LastUpdate' : 'آخر تحديث :'
};
export default data;
